import { getDefaultConfig } from "@rainbow-me/rainbowkit";
import { createConfig, http, webSocket, } from "wagmi";
import { CHAIN_ID, mezoMainnet, mezoTestnet, RPC_BY_NETWORK } from "./constants";
import { getOKXWallet, getUnisatWallet, getXverseWallet } from "./wallet";
const transports = {
    [CHAIN_ID.mainnet]: http(RPC_BY_NETWORK.mainnet.http),
    [CHAIN_ID.testnet]: http(RPC_BY_NETWORK.testnet.http),
};
export const defaultConfig = {
    transports,
    walletConnectProjectId: "",
    chains: [mezoMainnet, mezoTestnet],
    multiInjectedProviderDiscovery: true,
};
const bitcoinWalletTestnetConfig = {
    rpcUrl: RPC_BY_NETWORK.testnet.http,
    chainId: CHAIN_ID.testnet,
};
const bitcoinWalletMainnetConfig = {
    rpcUrl: RPC_BY_NETWORK.mainnet.http,
    chainId: CHAIN_ID.mainnet,
};
export const unisatWalletMezoTestnet = getUnisatWallet(bitcoinWalletTestnetConfig);
export const okxWalletMezoTestnet = getOKXWallet(bitcoinWalletTestnetConfig);
export const xverseWalletMezoTestnet = getXverseWallet(bitcoinWalletTestnetConfig);
export const unisatWalletMezoMainnet = getUnisatWallet(bitcoinWalletMainnetConfig);
export const okxWalletMezoMainnet = getOKXWallet(bitcoinWalletMainnetConfig);
export const xverseWalletMezoMainnet = getXverseWallet(bitcoinWalletMainnetConfig);
export function getDefaultWallets(network = "mainnet") {
    return [
        {
            groupName: "Bitcoin",
            wallets: network === "mainnet"
                ? [
                    unisatWalletMezoMainnet,
                    okxWalletMezoMainnet,
                    xverseWalletMezoMainnet,
                ]
                : [
                    unisatWalletMezoTestnet,
                    okxWalletMezoTestnet,
                    xverseWalletMezoTestnet,
                ],
        },
    ];
}
export function getConfig(config) {
    const { appName, mezoNetwork = "mainnet", walletConnectProjectId = defaultConfig.walletConnectProjectId, ...restParameters } = config;
    const wallets = config.bitcoinWallets ?? [...getDefaultWallets(mezoNetwork)];
    return getDefaultConfig({
        ...defaultConfig,
        appName,
        wallets,
        projectId: walletConnectProjectId,
        ...restParameters,
    });
}
/**
 * This config is only used to listen for Transfer events on mezo chain.
 * Should not be exported in index for public use.
 */
export const simpleWssMezoConfig = createConfig({
    chains: [mezoMainnet, mezoTestnet],
    transports: {
        [mezoMainnet.id]: webSocket(RPC_BY_NETWORK.mainnet.webSocket),
        [mezoTestnet.id]: webSocket(RPC_BY_NETWORK.testnet.webSocket),
    },
});
//# sourceMappingURL=config.js.map